import React from "react";
import {
  StyledTable,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableWrapper,
} from "../../CustomTable/index.styled";
import { SquareSkeleton, TextSkeleton } from "../index.styled";

const TableSkeleton = ({ columns }) => {
  const data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <TableWrapper animate={true}>
      <StyledTable isVisible={true}>
        <TableHeader>
          {columns.map((column, index) => (
            <TableHeaderCell key={index}>
              {column.header === "Sr." || column.header === "" ? (
                <SquareSkeleton />
              ) : column.header === "Hospital Name" ? (
                <TextSkeleton width={14} />
              ) : column.header === "CMS Rating" ||
                column.header === "No. of Beds." ? (
                <TextSkeleton width={4} />
              ) : (
                <TextSkeleton width={8} />
              )}
            </TableHeaderCell>
          ))}
        </TableHeader>
        <tbody>
          {data.map((row, rowIndex) => {
            return (
              <TableRow key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <TableCell key={colIndex}>
                    {column.header === "Sr." || column.header === "" ? (
                      <SquareSkeleton />
                    ) : column.header === "Hospital Name" ? (
                      <TextSkeleton width={14} />
                    ) : column.header === "CMS Rating" ||
                      column.header === "No. of Beds." ? (
                      <TextSkeleton width={4} />
                    ) : (
                      <TextSkeleton width={8} />
                    )}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default TableSkeleton;
